import React from "react";
import configData from "../config/config.json";
import helper from "../data/Helper";

const errorscreen = (props) => {
  const toMaybankHome = () => {
    helper.toHomeScreen();
  };
  return (
    <div className=" mt-3">
      <div className="outerdivsubheader">
        <div className="row">
          <div className="col-12">
            <h2 className="welcome mb-0">{configData.APP_NAME}</h2>
          </div>
        </div>
        <div className="DynaForm DynamicFields">
          <div className="col-12">
            <p className="Dynamiccenteralign mb-0">{configData.APP_NAMEHDR}</p>
          </div>
          <hr className="panelLine"></hr>
          <div
            className="panel-collapse collapse in"
            style={{ padding: "10px" }}
          >
            <div className="panel-body" style={{ padding: "25px" }}>
              <div className="DynamicFieldstretchRuIL  flex-row">
                <div className="Dynamiccenteralign" style={{ padding: "10px" }}>
                  <h3> Sorry, we are unable to process your information.</h3>
                </div>
              </div>
              <div className="DynamicFieldstretchRuIL  flex-row">
                <div className="Dynamiccenteralign" style={{ padding: "10px" }}>
                  <h4 style={{ fontweight: "600" }}>
                    {" "}
                    Please resubmit the application form and ensure that the details submitted are accurate.
                  </h4>
                  <p>If you still have trouble submitting the application, please get in touch at 1800-629-2265</p>
                </div>
              </div>

              <br></br>

              <div className="DynamicFieldstretchRuIL flex-row">
                <button
                  type="button"
                  onClick={toMaybankHome}
                  id="backtoHomebtn"
                  className="null  btn btn-success"
                >
                  Application Page
                </button>
              </div>
              <br></br>
              <br></br>
              <div className="well welcomeNote" style={{ padding: "10px" }}>
                <div className="row"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default errorscreen;
